import { render, staticRenderFns } from "./AuxiliaryApproversEdit.vue?vue&type=template&id=6d95a4b2&scoped=true&"
import script from "./AuxiliaryApproversEdit.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryApproversEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d95a4b2",
  null
  
)

export default component.exports